// Image imports
import chaimPeriPortrait from '../../../images/chaim-peri.jpg';

export const chaimPeriMemorial = {
  id: 19,
  name: 'Chaim Peri',
  category: 'community-leaders',
  images: {
    portrait: chaimPeriPortrait
  },
  info: `

"He lived for his community and died because of his love for it." - Friend of Chaim

# Chaim Peri

![Chaim Peri](${chaimPeriPortrait})
*Chaim Peri, whose life was dedicated to building Kibbutz Nir Oz*

## A Founding Father

Chaim Peri was 80 years old and one of the founding members of Kibbutz Nir Oz when Hamas terrorists attacked on October 7th, 2023. His life story was intertwined with the history of the kibbutz itself - he had helped build it from the ground up and dedicated his life to its community.

On that terrible morning, Chaim was taken hostage from the home he had lived in for decades, beginning an ordeal that would last until his death in Hamas captivity.

## A Life of Service

Those who knew Chaim speak of his unwavering commitment to the ideals of the kibbutz movement. He believed deeply in collective living and shared responsibility. For many years, he had managed the kibbutz's agricultural operations, helping it prosper even in the challenging conditions of Israel's south.

In his later years, though officially retired, Chaim remained active in kibbutz life. He volunteered in the community garden, taught agricultural techniques to younger members, and served on committees that shaped the kibbutz's future. His institutional memory was invaluable - he could recall the history of every field, every building, and every major decision in the kibbutz's development.

## A Family Man

Beyond his dedication to the kibbutz, Chaim was a devoted husband, father, and grandfather. His family described him as someone who lived his values every day, teaching through example rather than words.

His grandchildren recalled how he would take them on walks around the kibbutz, explaining the purpose of each building and telling stories about how it was built. He knew the name of every plant and could identify birds by their calls - knowledge he passed down with patience and enthusiasm.

## A Final Journey

On August 8, 2024, Israeli forces recovered Chaim's body along with five other elderly hostages from Gaza. After ten months in captivity, Chaim had died without seeing his beloved kibbutz or family again.

His funeral was held in Kibbutz Nir Oz, attended by multiple generations of kibbutz members. Former students from the agricultural courses he had taught came from across Israel to pay their respects. Many spoke of how Chaim had influenced their lives and careers through his knowledge and mentorship.

## Seeds of Memory

In Chaim's memory, the kibbutz has established an agricultural scholarship in his name, supporting young people who wish to study innovative farming techniques for Israel's arid regions. Additionally, a special section of the kibbutz's community garden has been dedicated to him, planted with his favorite varieties of vegetables and flowers.

Though Chaim Peri's life ended in tragedy, his legacy continues in the fields he cultivated, the people he mentored, and the community he helped build. As one eulogist noted, "The kibbutz that stands today is Chaim's monument - every tree, every field, every building carries his fingerprints."

May his memory be a blessing, and may the seeds he planted continue to grow and flourish.

`
};